import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6838c133"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pt-4" }, " План был рассчитан. Но допустимое распределение панелей в контейнеры не было найдено. Пожалуйста, проверьте исходные данные и повторите расчет. ", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pt-4" }, " План еще не рассчитан. Нажмите кнопку \"Рассчитать\" для расчета плана. ", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "card border-0" }
const _hoisted_12 = {
  class: "card-body",
  style: {"padding":"0"}
}
const _hoisted_13 = { class: "d-flex align-items-center pt-4" }
const _hoisted_14 = { class: "d-inline-block" }
const _hoisted_15 = {
  key: 0,
  class: "dx-button-text"
}
const _hoisted_16 = {
  key: 1,
  class: "dx-button-text"
}
const _hoisted_17 = {
  key: 0,
  class: "d-inline-block"
}
const _hoisted_18 = {
  key: 1,
  class: "d-inline-block px-2",
  style: {"width":"100%"}
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "progress" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "progress-bar progress-bar-striped progress-bar-animated",
    role: "progressbar",
    "aria-valuenow": "100",
    "aria-valuemin": "0",
    "aria-valuemax": "100",
    style: {"width":"100%","background-color":"#363b5d !important"}
  })
], -1))
const _hoisted_20 = { style: {"margin-top":"2px"} }
const _hoisted_21 = { class: "pt-2" }
const _hoisted_22 = { class: "pt-2" }
const _hoisted_23 = { class: "pt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_PlanOrderResultJournal = _resolveComponent("PlanOrderResultJournal")!
  const _component_PlanPanelResultJournal = _resolveComponent("PlanPanelResultJournal")!
  const _component_PlanContainerResultJournal = _resolveComponent("PlanContainerResultJournal")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.isPlanCompleted)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.isPlanNotFound)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_DxButton, {
                        class: "PlanResultsView-generateReportButton",
                        type: "default",
                        "styling-mode": "outlined",
                        onClick: _ctx.onButtonClick
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("span", null, [
                            (!_ctx.loading)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Сформировать отчет"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_16, "Остановить"))
                          ])
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    (!_ctx.loading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createVNode(_component_DxButton, {
                            type: "normal",
                            icon: "download",
                            disabled: _ctx.loading,
                            onClick: _ctx.onDownload,
                            hint: "Скачать отчет в виде pdf документа",
                            style: {"margin-left":"5px"}
                          }, null, 8, ["disabled", "onClick"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.loading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _hoisted_19,
                          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.timeMessage), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_PlanOrderResultJournal, { parentModel: _ctx.parentModel }, null, 8, ["parentModel"])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_PlanPanelResultJournal, { parentModel: _ctx.parentModel }, null, 8, ["parentModel"])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_PlanContainerResultJournal, { parentModel: _ctx.parentModel }, null, 8, ["parentModel"])
          ])
        ]))
  ]))
}